<template>
    <FKBreadCrumb :page="$t('page.roles')" />
    <RolesList/>
</template>
  
<script lang="ts">
import { defineComponent } from "vue";

import RolesList from "@/components/FK/Roles/RolesList.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";

export default defineComponent({
    name: "RolesPage",
    components: {
        FKBreadCrumb,
        RolesList,
    },
});
</script>